import script from "./PageSignals.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSignals.vue?vue&type=script&setup=true&lang=js"

import "./PageSignals.vue?vue&type=style&index=0&id=5fae9ed7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fae9ed7"]])

export default __exports__